import { render } from "./FirebaseUserVerifyEmail.vue?vue&type=template&id=db2933c0"
import script from "./FirebaseUserVerifyEmail.vue?vue&type=script&lang=js"
export * from "./FirebaseUserVerifyEmail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ra/Desktop/experiments/benchomatic/src/core-auth/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__